import React, { useState, useContext } from 'react'
import StateContext from '../StateContext'
import DispatchContext from '../DispatchContext'
import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Axios from 'axios';
import AuthTabs from './AuthenticationTabs';
import Slide from '@material-ui/core/Slide';

// Cookies functions
import { setCookie } from "../Functions/cookieFunction";
import { handleError } from '../Functions/getAlert';

const useStyles = makeStyles((theme) => ({
     root: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
     },
     wrapper: {
          marginTop: '1.5rem',
          position: 'relative',
     },
     buttonSuccess: {
          backgroundColor: green[500],
          '&:hover': {
               backgroundColor: green[700],
          },
     },
     fabProgress: {
          color: green[500],
          position: 'absolute',
          top: -6,
          left: -6,
          zIndex: 1,
     },
     buttonProgress: {
          color: green[500],
          position: 'absolute',
          top: '50%',
          left: '50%',
          marginTop: -12,
          marginLeft: -12,
     },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
     return <Slide direction="up" ref={ref} {...props} />;
});

const LoginModal = (props) => {

     const appState = useContext(StateContext)

     const [isLoading, setIsLoading] = useState(true)
     const theme = useTheme();
     const [fullWidth] = useState(true);
     const [maxWidth, setMaxWidth] = useState('sm')
     const [loading, setLoading] = useState(false)
     const [email, setEmail] = useState('')
     const [password, setPassword] = useState('')
     const appDispatch = useContext(DispatchContext)
     const classes = useStyles();
   
     const handleModalClose = () => {
          props.setOpenModal(false);
     };
     const handleSubmit = async e => {
          e.preventDefault();

          if (email && password !== '') {
               setLoading(true)
               try {
                    const response = await Axios.post(`${process.env.REACT_APP_API_URL}login/customer-login`, { email: email, password: password })
                    if (response.data.data.email === email) {
                         setLoading(false)
                         // setSuccess(true)
                         appDispatch({ type: "login", login: response.data.data.id, token: response.data.accessToken })
                         setCookie('tokenAuth', response.data.accessToken, 1)
                         props.setAlertMessage({ open: true, message: "Logged In Successfully", alertSuccess: true })
                         handleModalClose()
                    }
               } catch (e) {
                    setLoading(false)
                    handleError(e, appDispatch)

               }
          }
          else {
               setLoading(false)
               alert('fill')
               // setAlertMessage({ open: true, message: 'Please fill these fields!', alertSuccess: false })
          }
     }

     return (
          <React.Fragment>
               <Dialog
                    fullWidth={fullWidth}
                    maxWidth={maxWidth}
                    open={props.openModal}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleModalClose}
                    aria-labelledby="max-width-dialog-title"
               >
                    {/* <DialogTitle id="max-width-dialog-title" className="text-center"><h2>Login</h2></DialogTitle> */}
                    <DialogContent dividers>

                         <div className="container-fluid">
                              <AuthTabs setAlertMessage={props.setAlertMessage} />
                         </div>
                    </DialogContent>
                    {/* <DialogActions>
                         <Button onClick={handleModalClose} color="primary">
                              Close
                    </Button>
                    </DialogActions> */}
               </Dialog>
          </React.Fragment>
     );
}
export default LoginModal
